export const isHiddenTemple = (type: string): boolean => type === 'hidden_temples';
